module.exports = __webpack_public_path__ + "static/img/poster-bac.91e2b6cb.png";